import React from 'react';
import '../../styles/desktop-homepage-replica.css';

const DesktopFooter = () => {
  return (
    <footer className="dr-footer dr-footer--shell">
      <p className="mb-3">Built in India. For Solos Everywhere!</p>
      <p className="mb-2">
        <a href="/terms">Terms</a> · <a href="/privacy">Privacy</a> · <a href="/community-guidelines">Guidelines</a>
      </p>
      <p className="mb-2">
        STAGSTER.com is part of{' '}
        <a href="https://www.stagsterlabs.com" target="_blank" rel="noopener noreferrer">
          STAGSTER Labs LLP
        </a>{' '}
        · LLPIN: ACS-0188 · D-U-N-S: 771775839
      </p>
      <p>© {new Date().getFullYear()} STAGSTER. Solo access guaranteed.</p>
    </footer>
  );
};

export default DesktopFooter;
